// G-65: alliance emblem — a library icon tinted with a library colour; the tag's first letter when
// none is set.
import type { AllianceEmblem, AllianceEmblemIcon } from '@stars-and-ships/api-types';
import {
  Atom,
  Crown,
  Eye,
  Flame,
  type LucideIcon,
  Moon,
  Orbit,
  Rocket,
  Shield,
  Skull,
  Star,
  Sun,
  Swords,
} from 'lucide-react';

export const EMBLEM_ICONS: Record<AllianceEmblemIcon, LucideIcon> = {
  star: Star,
  planet: Orbit,
  moon: Moon,
  sun: Sun,
  rocket: Rocket,
  shield: Shield,
  swords: Swords,
  crown: Crown,
  skull: Skull,
  eye: Eye,
  atom: Atom,
  flame: Flame,
};

const BOX = { sm: 'size-7', md: 'size-10', lg: 'size-14' } as const;
const GLYPH = { sm: 'size-4', md: 'size-6', lg: 'size-8' } as const;

export function Emblem({
  emblem,
  tag,
  size = 'md',
}: {
  emblem: AllianceEmblem | null;
  tag: string;
  size?: keyof typeof BOX;
}) {
  const Icon = emblem ? EMBLEM_ICONS[emblem.icon] : undefined;
  return (
    <span
      role="img"
      aria-label={`Emblem of [${tag}]`}
      data-emblem-icon={emblem?.icon}
      style={emblem ? { color: emblem.color } : undefined}
      className={`${BOX[size]} inline-flex shrink-0 items-center justify-center hud-cut-sm border border-line-strong bg-void font-display font-bold ${emblem ? '' : 'text-muted'}`}
    >
      {Icon ? <Icon className={GLYPH[size]} aria-hidden /> : tag.charAt(0)}
    </span>
  );
}
